import React, { useState } from 'react'
import '../App.css'
import Topnav from './Topnav'
import Search from './Search'
import Chatlist from './Chatlist'
const Sidebar = () => {
  const [istoggle, settoggle] = useState(true)
  return (
    <div className='sidebar'>
      
      <Topnav /> 
      <Search /> 
      <Chatlist />
    </div>
  )
}

export default Sidebar